import GeoJSON from "ol/format/GeoJSON";
import proj from "ol/proj";
import { transformExtent } from 'ol/proj';

import layersMap from './../layer';
import services from "./services";
import commercialzoneLayersMap from './layer';
const $ = window.$;

const url = contextPath + "/rest/commercialspace/parcel/search/C"
const bigSmallMapBreakpoint = 768;

export default class Externals {
    constructor(map, ui) {
        this.map = map;
        this.ui = ui;
        this.mapRenderedSmall = false;
    }

    updateOpacity(value) {

        commercialzoneLayersMap.commercialspaceLayer.setOpacity(value / 100);
        commercialzoneLayersMap.parcelLayer.setOpacity(value / 100);

    }
    doDeselectAndHidePopup() {

        layersMap.selectLayer.getSource().clear();
        $(".selectinfo").hide();
        $(".map-inner .selectinfo").attr("data-status", "closed");
        $(".map-inner .selectinfo").attr("data-id", "");
    }
    doDeselect() {
        layersMap.selectLayer.getSource().clear();
    }

    doSearch() {
        var formElements = $("form").serializeArray();
        var inputdata = {};
        formElements.forEach(function (elem) {
            if (elem.name.startsWith("j_id") || elem.name === "currentPage" || elem.name === "j_idt13" || elem.name === "city_select" || elem.name === "javax.faces.ViewState") {
                return;
            }
            if (elem.name === "landuseDevType") {
                if (!(elem.name in inputdata)) {
                    inputdata[elem.name] = [];
                }
                inputdata[elem.name].push(elem.value);
            } else {
                inputdata[elem.name] = elem.value === "on" ? true : encodeURIComponent(elem.value);
            }
        })
        layersMap.searchResultLayer.getSource().clear();

        services.postData(url, inputdata)
            .then((data) => {
                var features = new GeoJSON().readFeatures(data, {
                    dataProjection: "EPSG:25832",
                    featureProjection: "EPSG:3857"
                });
                layersMap.searchResultLayer.getSource().addFeatures(features);
                this.map.getView().fit(
                    layersMap.searchResultLayer.getSource().getExtent())
            })
            .catch(function (error) {
                console.log(error)
            });
    }


    doHighlite(id) {
        layersMap.highliteLayer.getSource().clear();

        layersMap.searchResultLayer.getSource().forEachFeature(function (feature) {
            if (feature.getId() == id) {
                layersMap.highliteLayer.getSource().addFeature(feature.clone());
                return true;
            }
        });
    }


    zoomTo(extent) {
        if (typeof extent === 'string') {
            extent = extent.split(",").map((val) => parseFloat(val))
        }
        this.map.getView().fit(
            transformExtent(extent, "EPSG:25832", "EPSG:3857"))
    }


    //is used if search button is clicked, jsf ajax request is send. after response and updating dom this methode is called with 
    // data.status = 'success'
    //then we force map update size
    onSearchEvent(data) {
        var status = data.status; // Can be "begin", "complete" or "success".
        var source = data.source; // The parent HTML DOM element.

        switch (status) {
            case "begin": // Before the ajax request is sent.
                this.doSearch();
                break;

            case "complete": // After the ajax response is arrived.
                break;

            case "success": // After update of HTML DOM based on ajax response.
                $('#result-tab2').tab('show')
                this.ui.createPagination();
                //ui.initAutocomplete();
                break;
        }
    }

    onResetEvent(data) {
        var status = data.status; // Can be "begin", "complete" or "success".
        var source = data.source; // The parent HTML DOM element.

        switch (status) {
            case "begin": // Before the ajax request is sent.
                layersMap.searchResultLayer.getSource().clear();
                break;

            case "complete": // After the ajax response is arrived.
                break;

            case "success": // After update of HTML DOM based on ajax response.
                this.ui.initAutocompleteOptions();
                break;
        }
    }

    onPageEvent(data) {
        var status = data.status; // Can be "begin", "complete" or "success".
        var source = data.source; // The parent HTML DOM element.

        switch (status) {
            case "begin": // Before the ajax request is sent.
                break;
            case "complete": // After the ajax response is arrived.
                break;
            case "success": // After update of HTML DOM based on ajax response.
                this.ui.createPagination();
                setTimeout(function () {
                    this.map.updateSize()
                }.bind(this), 40)
                break;
        }
    }

    replaceMap() {

        if ($(window).width() < 768) {
            //we need a small map
            if (!this.mapRenderedSmall) {
                //map is currently big, render map to small
                this.map.setTarget($("#togglemap .map-inner")[0]);
                this.mapRenderedSmall = true;
            }
            //we need a big map
        } else {
            if (this.mapRenderedSmall) {
                //map is currently small, reder map to big
                //map tab is active, toggle to search in big view
                if ($('#map-tab.active').length) {
                    $('#search-tab2').tab('show');
                }
                this.map.setTarget($("#map")[0]);
                this.mapRenderedSmall = false;
            }
        }
    }
}